export default function isSuccessfulLink(query: string | URLSearchParams): boolean {
  const params = query instanceof URLSearchParams ? query : new URLSearchParams(query);
  return params.has('code');
}
